import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from 'react';
import { IonToast } from '@ionic/react';
import PropTypes from 'prop-types';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({
    message: '',
    show: false,
    duration: 2500,
    color: 'success',
    mobileMode: 'md',
  });
  useEffect(() => {
    if (toast.show) {
      setTimeout(() => {
        const toastElements = document.querySelectorAll('ion-toast');
        toastElements.forEach((toastEl) => {
          const shadow = toastEl.shadowRoot;
          if (shadow) {
            const wrapper = shadow.querySelector('.toast-wrapper');
            if (wrapper) {
              wrapper.style.background =
                toast.color === 'success' ? 'green' : 'red';
              wrapper.style.color = 'white';
            }
          }
        });
      }, 100);
    }
  }, [toast.show, toast.color]);

  const showToast = useCallback(
    (message, color = 'success', mobileMode = 'md', duration = 2500) => {
      setToast({ message, show: true, duration, mobileMode, color });
      setTimeout(
        () => setToast((prev) => ({ ...prev, show: false })),
        duration,
      );
    },
    [],
  );

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      <IonToast
        mode={toast.mobileMode}
        isOpen={toast.show}
        message={toast.message}
        duration={toast.duration}
        color='success'
        cssClass='custom-toast'
      />
    </ToastContext.Provider>
  );
};
ToastProvider.propTypes = {
  children: PropTypes.object,
};
export const useToast = () => useContext(ToastContext);
